export default __webpack_public_path__ + "static/media/S-026.6b9e270d.png";